import * as yup from "yup";
import { DEALER_TYPE_LIST } from "~/components/Forms/DealerPassportForm2/Base/options";

export const formResolver = (t) =>
  yup.object().shape({
    // DEPRECATED IN: PASDILER-1279 (возможно временно)

    // dealerType: yup
    //   .object()
    //   .shape({
    //     value: yup.string().required(t("validation.required")),
    //     label: yup
    //       .string()
    //       .oneOf(
    //         DEALER_TYPE_LIST.map((item) => item.label),
    //         "Invalid dealer type label"
    //       )
    //       .required(t("validation.required")),
    //   })
    //   .required(t("validation.required")),
    contractEndDate: yup.string().nullable(),
  });
